import type { ForwardedRef, ReactNode } from 'react';

import { forwardRef, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { IntlProvider as IntlProviderCore, LocalizationProvider as LocalizationProviderCore } from '@progress/kendo-react-intl';

import type { I18nProviderProps, I18nProviderRef } from './_.type';

import useI18nProviderHooks from './_.hook';

const IntlProvider = memo(IntlProviderCore);
const LocalizationProvider = memo(LocalizationProviderCore);

/** I18nProvider. */
export default memo(
  forwardRef(function I18nProvider(props: I18nProviderProps, ref: ForwardedRef<I18nProviderRef>): ReactNode {
    const { children } = props;

    const { i18n } = useTranslation();

    useI18nProviderHooks(props, ref);

    return (
      <LocalizationProvider language={i18n.language}>
        <IntlProvider locale={i18n.language}>{children}</IntlProvider>
      </LocalizationProvider>
    );
  }),
);
